export const ROLE_TRACERT_ADMINISTRATOR = "TraCertAdmin";
export const ROLE_COMPANY_ADMINISTRATOR = "CompanyAdmin";
export const ROLE_CREATOR = "Creator";
export const ROLE_READER = "Reader_level_1";
export const ROLE_READER_DOWNLOADER = "Reader_level_2";

export const USER_STATUS_ACTIVE = 1;
export const USER_STATUS_DISABLED = 2;
export const USER_STATUS_TEMP_DISABLED = 3;
export const USER_STATUS_NO_ACCOUNT = 4;